var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgApiToken = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 14.2323 22.7809 16.1799 20.9721 17.2133C20.9906 16.978 21 16.7401 21 16.5C21 16.1315 20.9779 15.7682 20.9348 15.4114C21.8932 14.5861 22.5 13.3639 22.5 12C22.5 9.51472 20.4853 7.5 18 7.5C17.5991 7.5 17.2105 7.55242 16.8406 7.65079C16.6111 7.71179 16.368 7.57159 16.3157 7.34004C15.5603 3.99669 12.5717 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 10.8973 2.20447 12.63 3.36611 13.9508C3.19703 14.5244 3.08355 15.1218 3.03191 15.7367C1.17215 14.088 0 11.6809 0 9C0 4.02944 4.02944 0 9 0C12.9278 0 16.2651 2.51482 17.4948 6.02105C17.6616 6.0071 17.8301 6 18 6C21.3137 6 24 8.68629 24 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0166 16.4652C10.3682 16.4652 9.02765 15.126 9.02765 13.4791C9.02765 11.8323 10.3682 10.493 12.0166 10.493C13.665 10.493 15.0055 11.8323 15.0055 13.4791C15.0055 15.126 13.665 16.4652 12.0166 16.4652ZM12.0166 9C9.54025 9 7.53318 11.0051 7.53318 13.4791C7.53318 14.4496 7.84552 15.3461 8.37083 16.08L1.5 22.9446L2.55659 24L3.62215 22.9354L4.65782 23.97L5.71515 22.9146L4.67874 21.88L6.15752 20.4023L7.20813 21.4523L8.26472 20.3965L7.21411 19.3469L9.42966 17.1335C10.1612 17.6516 11.0519 17.9583 12.0166 17.9583C14.4929 17.9583 16.5 15.9531 16.5 13.4791C16.5 11.0051 14.4929 9 12.0166 9Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgApiToken);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/api-token.474d6c40efbba89583833ce1f8ec89e8.svg";